import { Box, Divider, IconButton, Stack, Typography } from '@mui/material'
import { Delete } from '@mui/icons-material'
import { com } from '@eidu/web'
import { PermissionWithId } from '../input/PermissionsInput'
import actionLabel from '../../domain/permission/actionLabel'
import EntitySelectorPermission = com.eidu.sharedlib.entity.permission.EntitySelectorPermission
import EntityPathPermission = com.eidu.sharedlib.entity.permission.EntityPathPermission

type UnassignedPermissionsListProps = {
  permissions: readonly PermissionWithId[]
  onRemove: (id: string) => void
}

const UnassignedPermissionsList = ({ permissions, onRemove }: UnassignedPermissionsListProps) => {
  if (permissions.length === 0) return null
  return (
    <Box sx={{ border: 1, borderColor: 'warning.main', borderRadius: 1, p: 2 }}>
      <Typography variant="subtitle2" gutterBottom>
        Other permissions ({permissions.length})
      </Typography>
      <Typography variant="caption" color="text.secondary">
        These permissions use targets that don&apos;t map to a single entity type row (e.g. <code>And</code>,{' '}
        <code>Or</code>, <code>Not</code>). They are kept on save but are not editable from the matrix above.
      </Typography>
      <Divider sx={{ my: 1 }} />
      <Stack spacing={0.5}>
        {permissions.map(({ id, permission }) => (
          <Stack key={id} direction="row" alignItems="center" spacing={1}>
            <Typography variant="body2" sx={{ flex: 1 }}>
              {actionLabel(permission.action)} —{' '}
              {permission instanceof EntitySelectorPermission
                ? permission.targets.toString()
                : permission instanceof EntityPathPermission
                  ? `path → ${permission.path.toType.toString()}`
                  : 'global'}
            </Typography>
            <IconButton size="small" onClick={() => onRemove(id)} aria-label="Remove">
              <Delete fontSize="small" />
            </IconButton>
          </Stack>
        ))}
      </Stack>
    </Box>
  )
}

export default UnassignedPermissionsList
